import { types } from "mobx-state-tree";

export default types
  .model({
    id: types.number,
    title: types.string,
    status: types.string,
    note: types.maybeNull(types.string),
    chatRoomId: types.maybeNull(types.string),
    createdAt: types.string,
    premiumPurchaseId: types.string,
  })
  .actions((self) => ({
    update(values) {
      Object.assign(self, values);
      return self;
    },
  }));
